import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigProvider } from '../app-config/app-config';
/*
  Generated class for the ShariahServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ShariahServiceProvider {
  data: {
    token: string,
    app_key:string,
    user_id?: Number,
    portfolio_id?: Number,
    subportfolio_id?: Number,
    cart_id?: Number
  };

  constructor(private appConfig: AppConfigProvider, private http: HttpClient) {
    console.log('Hello ShariahServiceProvider Provider');
  }

  getUserBoughtItems(user_id: Number, subportfolio_id: Number = null) {
    this.data = {
      token: 'token',
      app_key: this.appConfig.appKey(),
      user_id,
      subportfolio_id
    }

    return this.http.post(this.appConfig.apiUrl() + 'index.php/api/subportfolio/isBought', this.data);
  }

  getPortfolios() {
    this.data = {
      token: 'token',
      app_key: this.appConfig.appKey(),
    }

    return this.http.post(this.appConfig.apiUrl() + 'index.php/api/portfolio/list', this.data);
  }

  getSubportfolios(portfolio_id: Number = null) {
    this.data = {
      token: 'token',
      app_key: this.appConfig.appKey(),
      portfolio_id
    }

    return this.http.post(this.appConfig.apiUrl() + 'index.php/api/subportfolio/list', this.data);
  }

  getContents(subportfolio_id: Number) {
    this.data = {
      token: 'token',
      app_key: this.appConfig.appKey(),
      subportfolio_id
    }

    return this.http.post(this.appConfig.apiUrl() + 'index.php/api/content/list', this.data);
  }

  getIntroSlider() {
    this.data = {
      token: 'token',
      app_key: this.appConfig.appKey(),
    }

    return this.http.post(this.appConfig.apiUrl() + 'index.php/api/landing/list', this.data);
  }

  getHomeIntro() {
    this.data = {
      token: 'token',
      app_key: this.appConfig.appKey(),
    }

    return this.http.post(this.appConfig.apiUrl() + 'index.php/api/intro/intro', this.data);
  }

  getCart(cart_id: Number = null) {
    this.data = {
      token: 'token',
      app_key: this.appConfig.appKey(),
      cart_id
    }

    return this.http.post(this.appConfig.apiUrl() + 'index.php/api/cart/list', this.data);
  }

  getUserCarts(user_id: Number = null) {
    this.data = {
      token: 'token',
      app_key: this.appConfig.appKey(),
      user_id
    }

    return this.http.post(this.appConfig.apiUrl() + 'index.php/api/cart/list', this.data);
  }

  getCartPayment(cart_id: Number = null) {
    this.data = {
      token: 'token',
      app_key: this.appConfig.appKey(),
      cart_id
    }

    return this.http.post(this.appConfig.apiUrl() + 'index.php/api/cart/get_payment', this.data);
  }
}



// WEBPACK FOOTER //
// ./src/providers/shariah-service/shariah-service.ts